import { Icons } from "../../utils/Icons";

const EmptyData = ({ title }: { title: string }) => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center gap-3">
      {Icons?.emptyData}
      <h4 className="empty-data-heading">{title}</h4>
    </div>
  );
};

export default EmptyData;
